import OtpInput from "react-otp-input";

const OtpInputBlock = ({ otp, setOtp }) => {
  return (
    <div className="double-otp-input-container mb-3">
      <OtpInput
        value={otp}
        onChange={setOtp}
        numInputs={6}
        isInputNum
        shouldAutoFocus
        renderInput={(props) => <input {...props} className="otp-input" />}
      />
    </div>
  );
};

export default OtpInputBlock;
